export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/3p_logo-bc97ae675528ec33b01bd6c26aeda064.svg";